<template>
  <v-card :elevation="$vuetify.breakpoint.smAndDown ? 0 : 2">
    <v-card-title primary class="title">Текущие документы</v-card-title>
    <template v-if="isLoading">
      <loading/>
    </template>
    <template v-else>
      <v-layout wrap>
        <v-flex xs12>
          <v-card-text class="text-xs-center text-sm-left">
            <v-btn
              v-if="!!_allowBB"
              color="accent"
              depressed
              small
              @click="$router.push({name: `catalog/newDocument`,params: {docName: 'rezervirovanie'}})"
            >
              Новое резервирование
            </v-btn>
            <v-btn
              v-if="!!_allowB"
              color="accent"
              depressed
              small
              @click="$router.push({name: `catalog/newDocument`,params: {docName: 'schet'}})"
            >
              Новый счет
            </v-btn>
          </v-card-text>
        </v-flex>
      </v-layout>
      <component
        :is="dashboardDocumentsComponent"
        :content="content"
        :currencies="currencies"
        :allowDeleteList="allowDeleteList"
        :statuses="statuses"
        @openDeleteConfirmationModal="openDeleteConfirmationModal"
        @openCatalog="openCatalog"
        @openDocument="openDocument"
      />
    </template>
    <dashboard-documents-delete-confirmation-modal
      ref="deleteConfirmationModal"
      @ok="deleteDocument"
    />
  </v-card>
</template>

<script>
import DocumentsApi from '../../documents/api'
import Loading from '@/components/helpers/Loading'
import { mapGetters } from 'vuex'
import DashboardDocumentsTable from './DashboardDocumentsTable'
import DashboardDocumentsList from './DashboardDocumentsList'
import DashboardDocumentsDeleteConfirmationModal from './DashboardDocumentsDeleteConfirmationModal'

export default {
  name: 'DashboardDocuments',
  components: {
    Loading,
    DashboardDocumentsTable,
    DashboardDocumentsList,
    DashboardDocumentsDeleteConfirmationModal
  },
  data () {
    return {
      isLoading: false,
      allowDeleteList: [
        'schet',
        'rezervirovanie'
      ],
      statuses: [],
      currencies: {},
      headers: [
        {
          text: '№',
          align: 'right',
          width: '100px',
          value: 'doc_id'
        },
        {
          text: 'Документ',
          width: '190px',
          value: 'doc_title'
        },
        {
          text: 'Дата',
          width: '200px',
          value: 'created_on'
        },
        {
          text: 'Сумма',
          width: '120px',
          align: 'right',
          value: 'summa'
        },
        {
          text: '',
          align: 'center',
          width: '145px',
          value: 'actions',
          sortable: false
        }
      ],
      content: []
    }
  },
  computed: {
    ...mapGetters('user', {
      _allowB: 'allowB',
      _allowBB: 'allowBB'
    }),
    dashboardDocumentsComponent () {
      return this.$vuetify.breakpoint.smAndDown ? 'dashboard-documents-list' : 'dashboard-documents-table'
    }
  },
  methods: {
    openDocument (document) {
      this.$router.push({ name: `documents/${document.name}`, params: { docId: document.doc_id } })
    },
    openDeleteConfirmationModal (item) {
      this.$refs.deleteConfirmationModal.open(item)
    },
    openCatalog (item) {
      this.$router.push({ name: 'catalog/document', params: { docId: item.doc_id, docName: item.name } })
    },
    async deleteDocument (item) {
      let response = await DocumentsApi.deleteDocument({ name: item.name, docId: item.doc_id })
      if (response.success) {
        this.loadData()
      } else {
        console.log(response.error)
      }
    },
    async loadData () {
      this.isLoading = true
      let response = await DocumentsApi.getList()
      if (response.success) {
        this.content = response.data
        this.statuses = response.statuses
        this.currencies = response.currencies
        this.isLoading = false
      } else {
        // console.log(response.error)
        this.isLoading = false
      }
    }
  },
  async mounted () {
    await this.loadData()
  }
}
</script>

<style>
</style>
